import styled, { css } from 'styled-components';

import { basicBodyTextStyle, Button } from '@dreryk/react-components';

export const StyledVideoConsultationWindowShowButton = styled(Button)`
   ${basicBodyTextStyle}
   border-radius: 20px;
   border: 2px solid ${(props) => props.theme.secondary};
   padding: 4px 12px;
   color: ${(props) => props.theme.secondaryDark};

   &:not(:disabled):hover {
      ${(props) => css`
         border-color: ${props.theme.secondaryDark};
         color: ${props.theme.secondaryDark};
         background: none;
      `}
   }
`;

StyledVideoConsultationWindowShowButton.displayName = 'StyledVideoConsultationWindowShowButton';
